module.exports = __webpack_public_path__ + "static/img/shangwei.62d0fa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shangwei.png
// module id = LfXA
// module chunks = 1